/* eslint-disable prefer-const */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-return-assign */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useImperativeHandle } from 'react';
import { COLOR } from 'assets/styles/colors';

const StripeInput = ({ component: Component, inputRef, ...other }) => {
  const [fontSizeStyle, setFontSizeStyle] = useState('16px');
  const elementRef = useRef();
  useImperativeHandle(inputRef, () => ({
      focus: () => elementRef.current.focus,
  }));

  let cardStyle = {
      style: {
        base: {
          color: `${COLOR.GREY_2}`,
          fontSize: fontSizeStyle,
          fontFamily: 'Barlow, sans-serif',
          fontStyle: 'normal',
          fontWeight: 'normal',
          '::placeholder': {
              color: 'transparent',
          },
        },
        invalid: {
          color: 'red',
        },
      },
    };

    window.addEventListener('resize', () => {
      if (window.innerWidth < 700) {
         setFontSizeStyle('14px');
      } else {
        setFontSizeStyle('16px');
      }
    });

    return (
        <Component
          onReady={(element) => (elementRef.current = element)}
          {...other}
          options={cardStyle}
        />
    );
};

export default StripeInput;
